import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../services/api.service';

@Component({
  selector: 'app-loginpage',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './loginpage.component.html',
})
export class LoginpageComponent implements OnInit {
  reactiveForm!: FormGroup;
  showPassword = false;
  errorMessage = '';
  isLoading = false;

  // ✅ Toast
  showToast = false;
  toastMessage = '';

  constructor(private router: Router, private route: ActivatedRoute, private apiService: ApiService) {}

  ngOnInit() {
    if (localStorage.getItem('userData')) {
      this.router.navigate(['/dashboard']);
      return;
    }

    this.reactiveForm = new FormGroup({
      user_name: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', [Validators.required]),
    });
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  showSuccess(message: string) {
    this.toastMessage = message;
    this.showToast = true;
    setTimeout(() => (this.showToast = false), 2500);
  }

  showError(message: string) {
    this.toastMessage = message;
    this.showToast = true;
    setTimeout(() => (this.showToast = false), 2500);
  }

  onSubmit() {
    if (this.reactiveForm.invalid) {
      this.reactiveForm.markAllAsTouched();
      return;
    }

    this.isLoading = true;
    const rememberMe = (document.getElementById('remember') as HTMLInputElement)?.checked;

    const body = {
      user_name: this.reactiveForm.value.user_name,
      user_password: this.reactiveForm.value.password,
      keep_log_in: rememberMe,
    };

    this.apiService.loginApi(body).subscribe({
      next: (res: any) => {
        console.log('Login response:', res);
        if (res.status === 200) {
          this.showSuccess('Login Successfully!');
          res.data.keep_log_in = rememberMe;
          localStorage.setItem('userData', JSON.stringify(res.data));
          const redirectUrl = localStorage.getItem('redirectAfterLogin');

          // Always navigate to /dashboard in production (do not use returnUrl)
          // short delay to let toast show
          setTimeout(() => {
            if (redirectUrl) {
              localStorage.removeItem('redirectAfterLogin');
              this.router.navigateByUrl(redirectUrl); // go to the saved URL
            } else {
              this.router.navigate(['/dashboard']); // default redirect
            }
          }, 200);
        } else {
          this.showError('Invalid Credentials');
          this.errorMessage = res.message;
        }
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Login error:', err);
        this.showError('An error occurred during login.');
        this.isLoading = false;
      },
    });
  }

  // We always redirect to dashboard after login in production.

}
